export default "__VITE_ASSET__DRali52U__"